import { isAdminUser } from './user';
import { hasDatePassed } from './utils';
import { ACTIVE, REJECTED, READY, REVIEW, STOPPED } from 'config/adStatusTypes';

export const getPaging = state => state.ads.paging;
export const getAdsById = state => state.ads.byId;
export const getAdById = (state, id) => getAdsById(state)[id];
export const shouldShowOnboarding = state => state.ads.onboarding.show;
export const getStatusFilter = state => state.ads.adFilters.status;
export const getSearchWord = state => state.ads.adFilters.searchWord;
export const getSortedBy = state => state.ads.adFilters.orderBy;
export const getReviewAudioTotal = state => state.ads.reviewAudioPaging.total;
export const fetchingReviewAudioAds = state => state.ads.fetchingReviewAudioList;
export const refreshingAds = state => state.ads.refreshingAdList;
export const getAdFilters = state => state.ads.adFilters;
export const errorRefreshingAds = state => state.ads.refreshAdsError;

export const hasStartDatePassed = ad => hasDatePassed(ad.dateBegin);
export const hasEndDatePassed = ad => hasDatePassed(ad.dateEnd);
export const getAdState = ad => ad.adState;
export const isAdStateOneOf = (ad, states) => states.some(state => state === getAdState(ad));
export const canReviewAd = ad => isAdStateOneOf(ad, [REVIEW]);
export const canCancelAd = ad => !hasEndDatePassed(ad) && isAdStateOneOf(ad, [READY, ACTIVE]);
export const canEditAd = ad => !hasEndDatePassed(ad) && isAdStateOneOf(ad, [READY, ACTIVE, REVIEW]);
export const canKickAd = (state, ad) => isAdminUser(state) && ad.processingFailed;
export const isAdRejected = ad => isAdStateOneOf(ad, [REJECTED]);
export const isAdStopped = ad => isAdStateOneOf(ad, [STOPPED]);



// WEBPACK FOOTER //
// ./src/selectors/ads.js